<template>
    <div id="question">
        <mt-loadmore :bottom-method="getFeedbackListHandler" :bottom-all-loaded="allLoaded"  :auto-fill="false" ref="loadmore">
            <ul>
                <li v-for="item in questions" :key="item.id">
                    <div class="liHeader">
                        <div>申请时间：{{ item.createTime }}</div>
                        <div>状态： {{item.stateName}}</div>
                    </div>
                    <div class="liMain">
                        <div v-if="item.state==0||item.state==1">快递单号：{{ item.smsNo }}</div>
                        <div  v-if="item.state!=0">激活时间：{{ item.activeTime }}</div>
                        <div>系统备注：{{ item.sysRemark }}</div>
                        <div v-if="item.state!=0 && item.state!=4" >新卡卡号：{{ item.newVriNo }}</div>
                        <div v-if="item.state==4">发放余额：{{ item.numPrice }} /元</div>
                    </div>
                    <!-- <div class="liFooter">
                        <div>{{ item.activeTime }}</div>
                        <div>
                            <mt-button type="primary" size="small" class="line-button line-button--mini" @click="goToDetail(item.id)">查看工单</mt-button>
                        </div>
                    </div> -->
                </li>
            </ul>
        </mt-loadmore>
    </div>
</template>
<script>
import { wxRequest } from '@/api/user'
import { Dialog } from 'vant';
export default {
    data(){
        return{
            questions: [],
            pageNo: 0,
            perPageNum: 20,
            allPage: 0,
            allLoaded: false
        }
    },
    methods: {
        showTxtByState(state){
            if(state == 1){
                return '未处理'
            }else if(state == 2){
                return '已处理'
            }
        },
        deleteFeedbackHandler(id){            
            this.$messagebox.confirm('您确定删除吗？').then(action => {
                if(action == 'confirm'){
                    wxRequest("user/tui/apply/sim/list", {id}, "post").then(res => {
                        if(res.data.code == 200){
                            this.$toast({
                                message: '删除成功',
                                position: 'middle',
                                duration: 1500
                            })
                            var disposeState = this.$route.query.disposeState;
                            this.getFeedbackListHandler(disposeState);
                        }
                    })
                }
            })
        },
        getFeedbackListHandler(disposeState){
            let data = {
                iccid: localStorage.getItem('iccid'),
                oldIccid: localStorage.getItem('iccid'),
                disposeState
            }
            wxRequest("user/tui/apply/sim/list", data, "post").then(res => {
                if(res.data.code == 200){
                    this.questions = this.questions.concat(res.data.data)  
                }
            })
        },
        goToDetail(id){
            this.$router.push('/user/questionDetail?id=' + id)
        }
    },
    watch:{
        '$route': function(to, from){
            var disposeState = to.query.disposeState;
            this.pageNo = 0;
            this.questions = [];
            this.allLoaded = false;
            this.getFeedbackListHandler(disposeState);            
            console.log('t:' + this.pageNo)
        }
    },
    created(){
        var disposeState = this.$route.query.disposeState;
        this.getFeedbackListHandler(disposeState);
    }    
}
</script>
<style lang="less">
#question {
    ul {        
        li {
            margin-top: 10px;
            background: #fff;
        }
        .liHeader, .liFooter {
            display: flex;
            justify-content: space-between;
            padding: 0 3%;
            line-height: 36px;
        }
        .liMain {
            min-height:60px;
            padding: 6px 3%;
            line-height: 1.5em;
            border-top: 1px solid #f0f0f0;
            border-bottom: 1px solid #f0f0f0;
            div {
                word-break: break-all;
            }
        }
        .liFooter button {
            margin-left: 10px;
        }
    }
}
</style>
